import { messageFadeindownModule } from '../../qp-ui-bootstrap/message-fadeindown';
import { RegistPartnerVerifyDirective } from './regist-partner-verify.directive'
import './regist-partner-verify.less';
import { RecaptchaHelper } from '@modules/common/tool/recaptcha/recaptcha-helper';
import '../../qp-ui-bootstrap/message-fadeindown/qp-message-fadeindown.less';

let RegistPartnerVerifyModule = angular.module("regist-partner-verify", [messageFadeindownModule.name])
    .directive({
        registPartnerVerify: RegistPartnerVerifyDirective
    })
RecaptchaHelper.loadGrecaptchaScriptLabel();
export { RegistPartnerVerifyModule }
